import { Link } from "react-router-dom";
import { Trophy, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Mark a won call: backend route first, falls back to creating the pipeline opportunity directly.
export const addWinToPipeline = async (p) => {
  try { const { data } = await api.post(`/admin/rcc/li/prospects/${p.id}/win`, {}); return { ok: true, id: data?.opportunity_id }; }
  catch (e) {
    if (e.response?.status !== 404) return { ok: false, error: errMsg(e) };
    try { const { data } = await api.post("/admin/rcc/opportunities", { name: `${p.company || `${p.first_name} ${p.last_name || ""}`.trim()} · ${p.job_title || p.open_roles || "Recruiting"}`, company_name: p.company || "", stage: "closed_won", notes: `Won on LinkedIn follow-up call with ${p.first_name} ${p.last_name || ""} (${p.email}).` }); return { ok: true, id: data?.id }; }
    catch (e2) { return { ok: false, error: e2.response?.status === 404 ? "Pipeline isn't live on the backend yet." : errMsg(e2) }; }
  }
};

export const WinBanner = ({ win, onClose }) => (
  <div className="tour-rise relative overflow-hidden rounded-2xl border border-[#D4AF37] bg-gradient-to-r from-[#D4AF37]/25 via-[#F3C649]/10 to-[#D4AF37]/25 p-4 shadow-[0_0_40px_rgba(212,175,55,0.35)]" data-testid="li-win-banner">
    <div className="flex items-center gap-3">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#D4AF37] text-black shadow-[0_0_25px_rgba(212,175,55,0.7)]"><Trophy className="h-6 w-6" /></span>
      <div className="min-w-0 flex-1">
        <p className="font-display text-xl text-[#F3C649]" data-testid="li-win-title">Won! {win.p.company || `${win.p.first_name} ${win.p.last_name || ""}`}</p>
        <p className="text-xs text-zinc-300" data-testid="li-win-status">{win.ok ? "Added to your pipeline as Closed Won." : `Couldn't add it to the pipeline: ${win.error}`}</p>
      </div>
      {win.ok && <Link to="/admin/rcc/pipeline" className="rounded-full bg-[#D4AF37] px-3 py-1.5 text-xs font-semibold text-black" data-testid="li-win-pipeline">Open pipeline</Link>}
      <button onClick={onClose} className="text-zinc-400 hover:text-white" aria-label="Close" data-testid="li-win-close"><X className="h-4 w-4" /></button>
    </div>
  </div>
);
